/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldData } from './FieldData';
import {
    FieldDataFromJSON,
    FieldDataFromJSONTyped,
    FieldDataToJSON,
} from './FieldData';

/**
 * 
 * @export
 * @interface OpportunityConfigBuilderRequest
 */
export interface OpportunityConfigBuilderRequest {
    /**
     * 
     * @type {string}
     * @memberof OpportunityConfigBuilderRequest
     */
    entityName: string;
    /**
     * 
     * @type {Array<FieldData>}
     * @memberof OpportunityConfigBuilderRequest
     */
    fields: Array<FieldData>;
}

/**
 * Check if a given object implements the OpportunityConfigBuilderRequest interface.
 */
export function instanceOfOpportunityConfigBuilderRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function OpportunityConfigBuilderRequestFromJSON(json: any): OpportunityConfigBuilderRequest {
    return OpportunityConfigBuilderRequestFromJSONTyped(json, false);
}

export function OpportunityConfigBuilderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityConfigBuilderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityName': json['entityName'],
        'fields': ((json['fields'] as Array<any>).map(FieldDataFromJSON)),
    };
}

export function OpportunityConfigBuilderRequestToJSON(value?: OpportunityConfigBuilderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityName': value.entityName,
        'fields': ((value.fields as Array<any>).map(FieldDataToJSON)),
    };
}

